import React from 'react'
import { Helmet } from 'react-helmet-async'
import { buildPageTitle } from '../../utils/pageTitle'
import { usePortalTitle } from '../../contexts/PortalTitleContext'
import { useContainerTitle } from '../../contexts/ContainerTitleContext'

type PageTitleProps = {
  resourceType?: string
  displayName?: string
}

const getDisplayName = (resourceType?: string, displayName?: string) => {
  if (displayName) return displayName
  if (resourceType) return resourceType.charAt(0).toUpperCase() + resourceType.slice(1)
}

const PageTitle: React.FC<PageTitleProps> = ({
  resourceType,
  displayName,
}) => {
  const portalTitle = usePortalTitle()
  const pageLocation = useContainerTitle()
  const typeName = getDisplayName(resourceType, displayName)
  const title = buildPageTitle(
    [`${typeName}`.trim(), pageLocation],
    portalTitle
  )
  return (
    <Helmet>
      <title>{title}</title>
    </Helmet>
  )
}

export default PageTitle